import Marionette from 'backbone.marionette';
import { Model } from 'backbone';

import {
	Rounds,
	Players,
	Squads,
	Positions,
	Venues,
	PlayersHistory
} from '../../collections';

import {
	Coach,
	FantasyTeam,
	Favourites,
	Compare,
	StatsBox,
	MatchStats,
} from "../../models";

import {
	StatsCentreView,
	PlayerProfileControls,
	StatsCentrePlayerPool,
	PlayerComparisonMain,
	PlayerComparisonNavigation,
	PlayerComparisonBoard,
	PlayerComparisonPlayerPool,
	PlayerComparisonChart,
	PlayerComparisonStatsBox,
	PlayerComparisonPlaceholderView,
	AdvertisingView,
} from '../../views';

import { isMobileView } from '../../utils';
import { sizes_for_big_ad } from '../../../../core/utils';

export default class StatsController extends Marionette.Object {
	statsCentre() {
		const
			rootView = this.getOption('rootView'),
			statsCentreView = new StatsCentreView({
				model: new Model(),
				team: new FantasyTeam(),
				players: new Players(),
				rounds: new Rounds(),
				squads: new Squads(),
				positions: new Positions(),
				favourites: new Favourites(),
				coach: new Coach(),
				venues: new Venues()
			});
		const advertisingFooter = new AdvertisingView({
			ad_id: 'div-gpt-ad-1607993981643-0',
			ad_path: 'stats-centre',
			size: [[160, 600], [300, 250], [970, 250], [728, 90]],
			pos: 3
		});

		statsCentreView.getRegion('pool').show(new StatsCentrePlayerPool({
			model: new Model()
		}));

		rootView.getRegion('main').show(statsCentreView);
		rootView.getRegion('ads_container').show(advertisingFooter);
	}

	playerProfile(player_id = 0) {
		const rootView = this.getOption('rootView');
		const playerProfile = new PlayerProfileControls({
			player_id,
			players: new Players(),
			rounds: new Rounds(),
			squads: new Squads(),
			venues: new Venues(),
			favourites: new Favourites(),
			positions: new Positions(),
			coach: new Coach(),
			model: new Model({
				squads: {},
				players: {},
				player: null
			}),
			match_stat: new MatchStats(),
			coach_stats: new MatchStats()
		});

		const advertisingTop  = new AdvertisingView({
			ad_id: 'profile-ad-slot-1',
			ad_path:'player-profile',
			size: sizes_for_big_ad(),
			pos: 1,

		});
		rootView.getRegion( 'top_ads_container' ).show( advertisingTop );
		//
		// //rightSidebarLayout.getRegion( 'content' ).show( playerProfile );
		rootView.getRegion('main').show(playerProfile);
	}

	playerComparison(player_id) {
		const rootView = this.getOption('rootView');

		if (isMobileView()) {
			rootView.getRegion('main').show(
				new PlayerComparisonPlaceholderView()
			);

			return;
		}

		const mainView = new PlayerComparisonMain({
			model: new Model(),
			players: new Players(),
			rounds: new Rounds(),
			squads: new Squads(),
			positions: new Positions(),
			favourites: new Favourites(),
			coach: new Coach(),
			venues: new Venues(),
			selected_player: player_id
		});

		mainView.getRegion('nav').show(new PlayerComparisonNavigation());

		mainView.getRegion('board').show(new PlayerComparisonBoard({
			model: new StatsBox()
		}));

		mainView.getRegion('chart').show(new PlayerComparisonChart({
			model: new Compare(),
			history: new PlayersHistory()
		}));

		mainView.getRegion('stats').show(new PlayerComparisonStatsBox({
			model: new StatsBox()
		}));

		mainView.getRegion('aside').show(new PlayerComparisonPlayerPool());

		rootView.getRegion('main').show(mainView);
	}
}